import React from 'react';
import FloatingCartButton from '../cart/FloatingCartButton';
import FloatingLogoutButton from './FloatingLogoutButton';
import { TbkConnectionProvider } from '../../context/TbkConnectionContext';

const MainLayout = ({ children, onLogout }) => {
    return (
        <TbkConnectionProvider>
            <div className="flex flex-col h-screen" style={{ backgroundColor: 'transparent' }}>
                <main className="flex-1 overflow-auto">
                    <div className="h-full">{children}</div>
                </main>
                <FloatingCartButton />
                <FloatingLogoutButton onLogout={onLogout} />
            </div>
        </TbkConnectionProvider>
    );
};

export default MainLayout;